import React, { useState, useEffect } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";

//Redux
import { useSelector } from "react-redux"; // useDispatch

//API
import ItemService from "../../../../services/supplier_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";
import Constants from "../../../../common/SupplierConstants";
import { formatNumber, isValidNumber } from "../../../../common/Validations";
import ApproveRemarksModal from "../../../../Components/Modal/supplier_app/ApproveRemarksModal";
import SuccessModal from "../../../../Components/Modal/supplier_app/SuccessModal";
import toast from "react-hot-toast";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";

const InvoiceDetails = () => {
  // const dispatch = useDispatch();

  localStorage.setItem("menu", "Purchasing");
  localStorage.setItem("submenu", "");

  let userInfo = useSelector((state) => state?.user?.data); // User Details from Store
  let invoiceNumber = useSelector(
    (state) => state?.purchasing?.purchase_order?.invoiceNumber
  ); // invoiceNumber from Store

  let workflow = useSelector(
    (state) => state?.purchasing?.purchase_order?.workflowPO
  ); // workflowPO from Store

  // invoice columns
  const invoiceDataColumns = [
    {
      name: "Invoice Item Nr",
      selector: (row) => row.invoiceItemNr,
      sortable: true,
      width: "150px",
    },
    {
      name: "GRN Nr",
      selector: (row) => row.grnNr,
      sortable: true,
      width: "130px",
    },
    {
      name: "Status",
      cell: (row) => (
        <>
          <span className="bg-table-status bg-table-info-status">{"New"}</span>
        </>
      ),
      width: "150px",
    },
    {
      name: "Material/Service",
      selector: (row) => row.materialCode,
      cell: (row) => (
        <>
          <div>
            <p className="m-0 p-0 pt-1">{row.materialCode} </p>
            <p className="m-0 p-0">{row.materialDescription} </p>
          </div>
        </>
      ),
      width: "180px",
      sortable: true,
    },
    {
      name: "GRN Qty",
      selector: (row) => row.grnQuantity,
      cell: (row) => <>{row.grnQuantity}</>,
      sortable: true,
      width: "150px",
    },
    {
      name: "Invoice Qty",
      cell: (row) => <>{row.invoiceQuantity}</>,
      sortable: true,
      width: "160px",
    },
    {
      name: "Invoice Balance Qty",
      cell: (row) => <>{row.invBalancePurchaseQuantity}</>,
      sortable: true,
      width: "180px",
    },
    {
      name: "Oder Unit",
      selector: (row) => row.orderUnitOfMeasure,
      sortable: true,
      width: "120px",
    },
    {
      name: "Original Unit Price",
      // selector: (row) => row.orderPriceUnit,
      cell: (row) => <>{row.originalUnitPrice}</>,
      sortable: true,
      width: "120px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.orderPriceUnit || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderPriceUnit"
          placeholder=""
          value={row.orderPriceUnit}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={getEditable}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Item Value",
      selector: (row) => row.totalPrice,
      cell: (row) => <>{formatNumber(row.totalPrice, "comma")}</>,
      sortable: true,
      width: "140px",
    },
    {
      name: "Tax Code",
      selector: (row) => row.taxCode,
      sortable: true,
      width: "130px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount,
      cell: (row) => <>{formatNumber(row.taxAmount, "comma")}</>,
      sortable: true,
      width: "140px",
    },
    {
      name: "Total Value",
      selector: (row) => row.netValue,
      cell: (row) => <>{formatNumber(row.netValue, "comma")}</>,
      sortable: true,
      width: "180px",
    },
    {
      name: "Currency",
      selector: (row) => row.currencyCode,
      sortable: true,
      width: "120px",
    },
    {
      name: "Remarks",
      selector: (row) => row.remarks || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="remarks"
          placeholder=""
          value={row.remarks}
          onChange={(event) =>
            handleInputChange(row.local_id, event, "REMARKS")
          }
          disabled={getEditable}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "Tax Desc",
      selector: (row) => row.taxIdDesc,
      sortable: true,
      width: "200px",
    },
    {
      name: "PReq Nr",
      selector: (row) => row.purchaseReqNr,
      sortable: true,
      width: "200px",
    },
    {
      name: "PReq Item Nr ",
      selector: (row) => row.purchaseReqitemNr,
      sortable: true,
      width: "200px",
    },
  ];
  //invoice OCR colums
  const invoiceDataOcrColumns = [
    {
      name: "Invoice Item Nr",
      selector: (row) => row.invoiceItemNr,
      sortable: true,
      width: "150px",
    },
    {
      name: "Material",
      selector: (row) => row.materialCode,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <p className="m-0 p-0 pt-1 fw-bold">{row.materialCode} </p>
          <p className="m-0 p-0">{row.materialLongText} </p>
        </div>
      ),
    },
    {
      name: "Invoice Qty",
      // cell: (row) => <>{row.orderQuantityLoad}</>,
      cell: (row) => <>{row.invoiceQuantity}</>,
      sortable: true,
      width: "160px",
    },
    {
      name: "Invoice Balance Qty",
      cell: (row) => <>{row.invBalancePurchaseQuantity || "0.00"}</>,
      sortable: true,
      width: "180px",
    },
    {
      name: "Oder Unit",
      selector: (row) => row.orderUnitOfMeasure || "KG",
      sortable: true,
      width: "120px",
    },
    {
      name: "Original Unit Price",
      // selector: (row) => row.orderPriceUnit,
      cell: (row) => <>{row.originalUnitPrice}</>,
      sortable: true,
      width: "180px",
    },
    {
      name: "Unit Price",
      selector: (row) => row.orderPriceUnit || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderPriceUnit"
          placeholder=""
          value={row.orderPriceUnit}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={getEditable}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Remarks",
      selector: (row) => row.remarks || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="remarks"
          placeholder=""
          value={row.remarks}
          onChange={(event) =>
            handleInputChange(row.local_id, event, "REMARKS")
          }
          disabled={getEditable}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Item Value",
      selector: (row) => row.totalPrice,
      cell: (row) => <>{formatNumber(row.totalPrice, "comma")}</>,
      sortable: true,
      width: "140px",
    },
    {
      name: "Tax Code",
      selector: (row) => row.taxCode,
      sortable: true,
      width: "130px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.basicAmount,
      cell: (row) => <>{formatNumber(row.taxAmount, "comma")}</>,
      //  cell: (row) => {
      //   const netValue = parseFloat(row.basicAmount) || 0;
      //   const tax = netValue * 0.18;
      //   return <>{formatNumber(tax, "comma")}</>;
      // },
      sortable: true,
      width: "140px",
    },
    {
      name: "Total Value",
      selector: (row) => row.netValue,
      cell: (row) => <>{formatNumber(row.netValue, "comma")}</>,
      sortable: true,
      width: "180px",
    },
    // {
    //   name: "Total Value",
    //   selector: (row) => row.netValue,
    //   cell: (row) => {
    //     const netValue = parseFloat(row.netValue) || 0;
    //     const tax = netValue * 0.18;
    //     const totalWithTax = netValue + tax;
    //     return <>{formatNumber(totalWithTax, "comma")}</>;
    //   },
    //   sortable: true,
    //   width: "200px",
    // },

    {
      name: "Currency",
      selector: (row) => row.currencyCode || "INR",
      // selector: (row) => "INR",
      sortable: true,
      width: "120px",
    },

    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate,
      sortable: true,
      width: "140px",
    },
    {
      name: "Tax Desc",
      selector: (row) => row.taxIdDesc,
      sortable: true,
      width: "200px",
    },
    {
      name: "PReq Nr",
      selector: (row) => row.purchaseReqNr,
      sortable: true,
      width: "200px",
    },
    {
      name: "PReq Item Nr ",
      selector: (row) => row.purchaseReqitemNr,
      sortable: true,
      width: "200px",
    },
  ];

  const handleInputChange = (local_id, event, type) => {
    const { name, value } = event.target;
    if (type === "REMARKS") {
      setData((prevRows) =>
        prevRows.map((row) => {
          return row.local_id === local_id
            ? {
                ...row,
                remarks: value,
              }
            : row;
        })
      );
    } else {
      if (isValidNumber(value)) {
        setData((prevRows) =>
          prevRows.map((row) => {
            return row.local_id === local_id
              ? {
                  ...row,
                  [name]: value,
                  totalPrice: Number(row.invoiceQuantity * value),
                  taxAmount: Number(row.invoiceQuantity * value) * (12 / 100),
                  netValue:
                    Number(row.invoiceQuantity * value) +
                    Number(row.invoiceQuantity * value) * (12 / 100),
                }
              : row;
          })
        );
      }
    }
  };

  const [data, setData] = useState([]);
  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);

  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);

  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line no-unused-vars
  const [getDisabledStatus, setDisabledStatus] = useState(true);

  const [modalShow, setModalShow] = useState(false);
  const [getEditable, setEditable] = useState(true);
  const [getAction, setAction] = useState("");

  /* success modal */
  const successModalData = {
    title: "Message",
    successMsg: "",
  };
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getsucceModalData, setsucceModalData] = useState(successModalData);
  const [getNextNavigate, setNextNavigate] = useState("");
  const onSuccessmodel = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const [formInputs, setFormInputs] = useState({
    transactionActivity: "INV",
    subTransactionActivity: "GRN",
    vendorCode: "",
    purchasingDocumentNr: "",
    purchasingDocumentDate: "",
    purchasingDocumentValue: "",
    currency: "",
    currencyCode: "",
    paymentTerms: "",
    totalInvoiceAmount: "",
    sumOfCurrentAmt: "",
    notes: "",
    weighSlipQty: "",
    itemClass: "",
    vendorInvoiceNo: "",
    vendorInvoiceDate: "",
    vendorInvoiceCurrency: "",
    vendorBasicValue: "",
    vendorFreightValue: "",
    vendorTaxValue: "",
    vendorOtherChargesValue: "",
    vendorTotalInvoiceValue: "",
    invoicedValue: "",
    generatedBy: "",
    createdBy: "",
  });

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };

  // load loadInitialPageData data on page load
  const loadInitialPageData = async () => {
    setLoading(true);
    if (invoiceNumber) {
      let obj = {
        documentNumber: invoiceNumber,
      };
      const toastId = toast.loading("Loading...", {
        position: "top-right",
      });

      await ItemService.getInvoiceDetail(obj).then((item) => {
        // console.log(">> res!", item);
        if (item?.status === 200) {
          let itemData = item?.data[0]?.items;
          const singleItem = item?.data?.[0];
          let cleanedItem = {};

          if (singleItem && typeof singleItem === "object") {
            cleanedItem = { ...singleItem };
            if (cleanedItem.hasOwnProperty("")) {
              delete cleanedItem[""];
            }

            // --- Map API keys to the field keys the UI renders ---
            // (No fields/keys are removed; we only fill in aliases/derived values)

            // Invoice Bill Document / attachment
            if (!cleanedItem.invoiceBillDocument && cleanedItem.attachmentId) {
              cleanedItem.invoiceBillDocument = cleanedItem.attachmentId;
            }
            // Supporting Document fallback to the same attachment
            if (!cleanedItem.supportingDocument && cleanedItem.attachmentId) {
              cleanedItem.supportingDocument = cleanedItem.attachmentId;
            }
            // PO Value - fallback to the invoice total when the PO value is absent
            if (!cleanedItem.purchasingDocumentValue) {
              cleanedItem.purchasingDocumentValue =
                cleanedItem.vendorTotalInvoiceValue ||
                cleanedItem.purchasingDocumentValue ||
                0;
            }
            // Weigh Slip Qty = sum of the invoice quantities
            if (
              !cleanedItem.totalOrderQuantity &&
              Array.isArray(singleItem.items) &&
              singleItem.items.length
            ) {
              cleanedItem.totalOrderQuantity = singleItem.items.reduce(
                (sum, it) => sum + (Number(it.invoiceQuantity) || 0),
                0
              );
            }

            // Map / derive the item-level columns the grid renders
            const itemRows = Array.isArray(singleItem.items)
              ? singleItem.items
              : [];
            cleanedItem.items = itemRows.map((it, idx) => {
              const qty =
                Number(it.invoiceQuantity) || Number(it.quantity) || 0;
              const unitPrice =
                Number(it.unitPrice) ||
                Number(it.orderPriceUnit) ||
                Number(it.originalUnitPrice) ||
                0;
              const itemValue = unitPrice * qty || Number(it.totalPrice) || 0;
              return {
                ...it,
                local_id: it.local_id ?? idx + 1,
                orderUnitOfMeasure:
                  it.orderUnitOfMeasure || it.uOM || it.unit || "",
                originalUnitPrice: it.originalUnitPrice ?? unitPrice,
                orderPriceUnit: it.orderPriceUnit ?? unitPrice,
                invoiceQuantity: it.invoiceQuantity ?? it.quantity ?? 0,
                totalPrice: it.totalPrice ?? itemValue,
                netValue: it.netValue ?? itemValue,
                taxAmount: it.taxAmount ?? 0,
                grnQuantity: it.grnQuantity ?? it.invoiceQuantity ?? 0,
                invBalancePurchaseQuantity:
                  it.invBalancePurchaseQuantity ?? 0,
                currencyCode:
                  it.currencyCode || cleanedItem.currencyCode || "INR",
              };
            });
            itemData = cleanedItem.items;
          }
          setFormInputs((formInputs) => ({
            ...formInputs,
            ...cleanedItem,
          }));
          setData(itemData);
        } else {
          toast.error(item?.message || "Please try again !!", {
            duration: 4000,
            position: "top-right",
          });
        }
        toast.dismiss(toastId);
      });

      setLoading(false);
    } else {
      window.history.back();
    }
  };

  // eslint-disable-next-line no-unused-vars
  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };

  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  useEffect(() => {
    loadInitialPageData();

    if (workflow?.workflow_record?.decision?.length > 0) {
      if (
        userInfo?.roles[0]?.roleId === "CommercialTeam" ||
        userInfo?.roles[0]?.roleId === "CommercialHead"
      ) {
        setEditable(false);
      } else {
        setEditable(true);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [invoiceNumber]);

  useEffect(() => {
    const totals = data.reduce(
      (acc, item) => {
        acc.totalPrice += Number(item.totalPrice);
        acc.taxAmount += Number(item.taxAmount);
        return acc;
      },
      { totalPrice: 0, taxAmount: 0 }
    );

    setFormInputs((formInputs) => ({
      ...formInputs,
      vendorBasicValue: totals.totalPrice,
      vendorTaxValue: totals.taxAmount,
    }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  // Workflow
  const navigateToWorkflow = () => {
    window.history.back();
  };
  const showApproveModal = async (name) => {
    setModalShow(true);
    setAction(name);
  };
  const workflowApproveReject = async (remarks) => {
    let obj = {};
    let bodyObj = workflow?.workflow_record?.workflowActionAPI?.Body;

    formInputs.items = data;
    formInputs.vendorTotalInvoiceValue =
      Number(formInputs?.vendorBasicValue) +
      Number(formInputs?.vendorTaxValue) +
      Number(formInputs?.vendorOtherChargesValue) +
      Number(formInputs?.vendorFreightValue);

    obj._id = workflow?.workflow_record?._id;
    obj.businessComponentId = workflow?.workflow_record?.businessComponentId;
    obj.eventId = workflow?.workflow_record?.eventId;
    obj.businessComponentInstanceId =
      workflow?.workflow_record?.businessComponentInstanceId;
    obj.stepId = workflow?.workflow_record?.stepId;
    obj.action = getAction;
    obj.remark = remarks;
    obj.editContextData = workflow?.workflow_record?.editContextData;
    obj.editForm = workflow?.workflow_record?.editForm;
    obj.data = formInputs;
    let newObj = { ...bodyObj, ...obj };

    //Approve
    await ItemService.workflowApproveReject(newObj).then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        successModalData.successMsg =
          getAction === "Approve"
            ? "Approved Successfully !!"
            : "Rejected Successfully !!";
        setsucceModalData(successModalData);
        setNextNavigate(Constants.INBOX);
        onSuccessmodel();
      } else {
        console.log(">> Error: Loading workflowApproveReject");
      }
    });
  };
  const handleValueChange = (remarks) => {
    workflowApproveReject(remarks);
  };
  const hideModal = () => {
    setModalShow(false);
  };

  const selectedColumns =
    (formInputs?.invoiceType ?? "NotOCR") === "OCR"
      ? invoiceDataOcrColumns
      : invoiceDataColumns;

  const toInputDate = (dateStr) => {
    if (!dateStr) return "";
    // Already in ISO format (yyyy-mm-dd) → pass through
    if (/^\d{4}-\d{2}-\d{2}/.test(dateStr)) return dateStr;
    const parts = dateStr.split("-");
    if (parts.length !== 3) return dateStr;
    const [day, month, year] = parts;
    // Handle month as a number (dd-mm-yyyy) or an abbreviation (dd-MMM-yyyy)
    const monthAbbrs = {
      Jan: "01", Feb: "02", Mar: "03", Apr: "04", May: "05", Jun: "06",
      Jul: "07", Aug: "08", Sep: "09", Oct: "10", Nov: "11", Dec: "12",
    };
    const monthNum = monthAbbrs[month] || String(Number(month)).padStart(2, "0");
    return `${year}-${monthNum}-${String(Number(day)).padStart(2, "0")}`; // returns YYYY-MM-DD
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />

      <Row className="justify-center subContent">
        <Col xs={12} md={12} lg={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Invoice Details :{" "} 
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {invoiceNumber}
              </span>
              <span>
                {formInputs?.invoiceStatusHeader === "Invoice Created" ? (
                  <span className="bg-table-status bg-table-new-status headerStatusDetailedPage">
                    {formInputs?.invoiceStatusHeader}
                  </span>
                ) : formInputs?.invoiceStatusHeader ===
                  "Pending for Approval" ? (
                  <span className="bg-table-status bg-table-progress-status headerStatusDetailedPage">
                    {formInputs?.invoiceStatusHeader}
                  </span>
                ) : formInputs?.invoiceStatusHeader === "Invoice Approved" ? (
                  <span className="bg-table-status bg-table-success-status headerStatusDetailedPage">
                    {formInputs?.invoiceStatusHeader}
                  </span>
                ) : (
                  formInputs?.invoiceStatusHeader
                )}
              </span>
            </h2>
            <p className="subText">Invoice Details</p>
            <hr />

            <Row className="mb-4">
              <Col xs={12} md={4} lg={4} className="text-left">
                <button
                  className="btnBack"
                  onClick={() => navigateToWorkflow()}
                >
                  <i className="bi bi-arrow-return-left"></i> Go Back
                </button>
              </Col>
              <Col xs={12} md={8} lg={8} className="text-right">
                {workflow?.workflow_record?.decision?.length > 0 &&
                  workflow?.workflow_record?.decision?.map((item, index) => (
                    <button
                      className={
                        item === "Approve" || item === "Submit"
                          ? "btnCommon btn-approve"
                          : "btnCommon btn-danger"
                      }
                      onClick={() => showApproveModal(item)}
                      key={index}
                    >
                      <i
                        className={
                          item === "Approve" || item === "Submit"
                            ? "bi bi-check2-circle"
                            : "bi bi-x-circle"
                        }
                      ></i>{" "}
                      {item}
                    </button>
                  ))}
              </Col>
            </Row>

            <>
              {/* Invoice header */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">GH</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">Invoice Header</span>
                        <span className="subHeaderTitle">Invoice Header</span>
                      </Col>

                      {/* <Col xs={2} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col> */}
                    </Row>
                  </h2>
                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Invoice Date"
                            name="vendorInvoiceDate"
                            placeholder=""
                            type="date"
                            value={toInputDate(formInputs?.vendorInvoiceDate)}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Invoice Value"
                            name="invoiceValue"
                            placeholder=""
                            value={formInputs?.vendorTotalInvoiceValue}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <InputField
                            className="inputBox"
                            label="Tax Amount"
                            name="vendorTaxValue"
                            placeholder=""
                            value={formInputs?.vendorTaxValue}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        {/* <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Invoice No "
                          name=""
                          placeholder=""
                          // value={""}
                          onChange={onInputChange}
                          disabled={false}
                        />
                      </Col> */}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <InputField
                            className="inputBox"
                            label="Currency"
                            name="currency"
                            placeholder=""
                            value={`${formInputs?.currencyCode} - ${formInputs?.currency}`}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <p className="fw-medium m-0">Invoice</p>
                          {(formInputs?.invoiceBillDocument && (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(formInputs?.invoiceBillDocument)
                              }
                            />
                          )) ||
                            "--"}
                        </Col>
                        {/* <Col
                                                    xs={12}
                                                    md={3}
                                                    lg={3}
                                                    className="commLeftRightPadding"
                                                  >
                                                    <FileUploadComponent
                                                      id="invoiceBillDocument"
                                                      name="invoiceBillDocument"
                                                      label="Invoice"
                                                      allowedTypes={[
                                                        "image/png",
                                                        "image/jpeg",
                                                        "application/pdf",
                                                      ]}
                                                      multiple={true} // Change to false for single file selection
                                                      required={true}
                                                      onSuccessUpload={onSuccessUploadDocumentType}
                                                      value={formInputs?.invoiceBillDocument || ""}
                                                      disabled={getDisabledStatus}
                                                    />
                                                  </Col>
                                                  <Col>
                                                    {(formInputs.invoiceBillDocument && (
                                                      <img
                                                        src="assets/img/newIcons/attached-file.png"
                                                        className="mt-1 attachmentIcon"
                                                        alt="attachments"
                                                        onClick={() =>
                                                          handleViewFile(formInputs?.invoiceBillDocument)
                                                        }
                                                      />
                                                    )) ||
                                                      "--"}
                                                  </Col> */}
                        {/* <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Invoice"
                            name=""
                            type="file"
                            placeholder=""
                            // value={""}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col> */}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <InputField
                            className="inputBox"
                            label="PO Number"
                            name="purchasingDocumentNr"
                            placeholder=""
                            value={formInputs?.purchasingDocumentNr}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <InputField
                            className="inputBox"
                            label="PO Value"
                            name="purchasingDocumentValue"
                            placeholder=""
                            value={formInputs?.purchasingDocumentValue}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <p className="fw-medium m-0">Supporting Document</p>
                          {(formInputs?.supportingDocument && (
                            <img
                              src="assets/img/newIcons/attached-file.png"
                              className="mt-1 attachmentIcon"
                              alt="attachments"
                              onClick={() =>
                                handleViewFile(formInputs?.supportingDocument)
                              }
                            />
                          )) ||
                            "--"}
                        </Col>
                        {/* <Col
                            xs={8}
                            md={3}
                            lg={3}
                            className="commLeftRightPadding"
                          >
                            <FileUploadComponent
                              id="supportingDocument"
                              name="supportingDocument"
                              label="Supporting Document"
                              allowedTypes={[
                                "image/png",
                                "image/jpeg",
                                "application/pdf",
                              ]}
                              multiple={true} // Change to false for single file selection
                              required={true}
                              onSuccessUpload={onSuccessUploadDocumentType}
                              value={formInputs?.supportingDocument || ""}
                              disabled={getDisabledStatus}
                            />
                          </Col>
                          <Col>
                            {(formInputs?.supportingDocument && (
                              <img
                                src="assets/img/newIcons/attached-file.png"
                                className="mt-1 attachmentIcon"
                                alt="attachments"
                                onClick={() =>
                                  handleViewFile(formInputs?.supportingDocument)
                                }
                              />
                            )) ||
                              "--"}
                          </Col> */}
                        {/* <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <InputField
                            className="inputBox"
                            label="Supporting Document"
                            name=""
                            type="file"
                            placeholder=""
                            // value={""}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col> */}
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <InputField
                            className="inputBox"
                            label="Vendor"
                            name="vendorCode"
                            placeholder=""
                            value={formInputs?.vendorCode}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <InputField
                            className="inputBox"
                            label="Vendor Name"
                            name="vendorName"
                            placeholder=""
                            value={formInputs?.vendorName}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Weigh Slip Qty"
                            name="totalOrderQuantity"
                            placeholder=""
                            value={formInputs?.totalOrderQuantity}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <InputField
                            className="inputBox"
                            label="Payment Terms"
                            name="paymentTerms"
                            placeholder=""
                            value={formInputs?.paymentTerms}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <TextAreaField
                            className="inputBox"
                            label="Notes "
                            name=""
                            placeholder=""
                            // value={""}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
              {/* invoice service itme details table*/}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible2
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility2}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">PI</span>
                      </Col>
                      <Col xs={12} md={8} lg={8}>
                        <span className="headerTitle">
                          Invoice Service Item Details
                        </span>
                        <span className="subHeaderTitle">
                          Invoice Service Item Details
                        </span>
                      </Col>
                    </Row>
                  </h2>
                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible2 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            // columns={invoiceDataColumns}
                            columns={selectedColumns}
                            data={data}
                            progressPending={loading}
                            paginationRowsPerPageOptions={
                              Constants.ROW_PER_PAGE
                            }
                            pagination
                            // paginationServer
                            // paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            selectableRows
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* other changes table */}
              {/* <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible5
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility5}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">OC</span>
                      </Col>

                      <Col xs={5} md={9} lg={9}>
                        <span className="headerTitle">Other Charges</span>
                        <span className="subHeaderTitle">
                          Other Charges Table{" "}
                        </span>
                      </Col>
                      <Col xs={2} md={1} lg={1} className="">
                        <button
                          className="btnTable"
                          onClick={showsetHeaderText}
                        >
                          <i className="bi bi-plus-lg"></i>
                        </button>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="">
                        <POCollabrationCommonFillter />
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible5 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <DataTable
                            // title=""
                            columns={HeaderTextColumns}
                            data={getHeaderTextSelectedData}
                            // progressPending={loading}
                            paginationRowsPerPageOptions={
                              Constants.ROW_PER_PAGE
                            }
                            pagination
                            // paginationServer
                            // paginationTotalRows={totalRows}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                            selectableRows
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div> */}

              {/* Pricing Summary */}
              {/* <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible6
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility6}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">PS</span>
                      </Col>
                      <Col xs={8} md={4} lg={4}>
                        <span className="headerTitle">Pricing Summary</span>
                        <span className="subHeaderTitle">Pricing Summary </span>
                      </Col>
                      <Col xs={2} md={1} lg={1} className="">
                        <POCollabrationCommonFillter />
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible6 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body p-2">
                      <Row className=" ms-3 ">
                        <Col
                          xs={8}
                          md={4}
                          lg={4}
                          className="d-flex my-2 jsutify-content-center align-items-center"
                        >
                          <p className="fw-medium">
                            SubTotal Pricing Schedule / Line Items
                          </p>
                        </Col>
                        <Col
                          xs={4}
                          md={6}
                          lg={6}
                          className="d-flex my-2 jsutify-content-center align-items-center"
                        >
                          <InputField
                            className="inputBox"
                            name="subTotalValue"
                            placeholder=""
                            value={subTotalValue}
                            disabled={true}
                          />
                        </Col>
                        <Col
                          xs={8}
                          md={4}
                          lg={4}
                          className="d-flex my-2 jsutify-content-center align-items-center "
                        >
                          <p className="fw-medium"> SubTotal Other Charges</p>
                        </Col>
                        <Col
                          xs={4}
                          md={7}
                          lg={7}
                          className="d-flex my-2 jsutify-content-center align-items-center "
                        >
                          <InputField
                            className="inputBox"
                            name="getOtherChargesValue"
                            placeholder=""
                            value={getOtherChargesValue}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={8}
                          md={4}
                          lg={4}
                          className="d-flex my-2 jsutify-content-center align-items-center"
                        >
                          <p className="fw-medium">Gross Total</p>
                        </Col>
                        <Col
                          xs={4}
                          md={7}
                          lg={7}
                          className="d-flex jsutify-content-center align-items-center"
                        >
                          <InputField
                            className="inputBox"
                            name="grossTotalValue"
                            placeholder=""
                            value={subTotalValue + getOtherChargesValue}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div> */}

              {/* invoice details */}
              <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible2
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility2}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">ID</span>
                      </Col>

                      <Col xs={4} md={8} lg={8}>
                        <span className="headerTitle"> Invoice details</span>
                        <span className="subHeaderTitle">Invoice details</span>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="">
                        <POCollabrationCommonFillter />
                      </Col>
                    </Row>
                  </h2>

                  <div
                    // id="acc"
                    className={`accordion-collapse collapse show ${
                      isCardVisible2 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row>
                        <Col xs={12} md={12} lg={12}>
                          <div className="accordion-body">
                            {/* {(formInputs?.invoiceType ?? "NotOCR") === "OCR" ? (
                              <>
                                <Row className="pt-2 pb-4">
                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={3}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Invoice Number"
                                      name="vendorInvoiceNo"
                                      id="vendorInvoiceNo"
                                      value={formInputs?.vendorInvoiceNo}
                                      disabled={true}
                                    />
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={3}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Invoice Date"
                                      name="vendorInvoiceDate"
                                      id="vendorInvoiceDate"
                                      value={formInputs?.vendorInvoiceDate}
                                      disabled={true}
                                    />
                                  </Col>

                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={3}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Delivery"
                                      name="vendorName"
                                      id="vendorName"
                                      value={formInputs?.vendorName}
                                      disabled={true}
                                    />
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={3}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Total Qty"
                                      name="totalOrderQuantity"
                                      id="totalOrderQuantity"
                                      value={formInputs?.totalOrderQuantity}
                                      disabled={true}
                                    />
                                  </Col>

                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={3}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Basic Price"
                                      name="dispBasicPrice"
                                      id="dispBasicPrice"
                                      // value={invoiceData?.dispBasicPrice}
                                      value={formatNumber(
                                        formInputs?.vendorBasicValue,
                                        "comma"
                                      )}
                                      disabled={true}
                                    />
                                  </Col>

                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={3}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="CGST"
                                      name="dispCGST"
                                      id="dispCGST"
                                      value={formInputs?.dispCGST}
                                      disabled={true}
                                    />
                                  </Col>

                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={3}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="SGST"
                                      name="dispSGST"
                                      id="dispSGST"
                                      value={formInputs?.dispSGST}
                                      disabled={true}
                                    />
                                  </Col>

                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={3}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Total Amount"
                                      name="vendorTotalInvoiceValue"
                                      placeholder="0.00"
                                      id="vendorTotalInvoiceValue"
                                      value={formatNumber(
                                        formInputs?.vendorTotalInvoiceValue,
                                        "comma"
                                      )}
                                      disabled={true}
                                    />
                                  </Col>
                                </Row>{" "}
                              </>
                            ) : ( */}
                            <>
                              {" "}
                              <Row className="pt-2 pb-4">
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Invoice Number"
                                    name="vendorInvoiceNo"
                                    id="vendorInvoiceNo"
                                    value={formInputs?.vendorInvoiceNo}
                                    onChange={onInputChange}
                                    disabled={getDisabledStatus}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Invoice Date"
                                    name="vendorInvoiceDate"
                                    placeholder=""
                                    type="date"
                                    value={toInputDate(
                                      formInputs?.vendorInvoiceDate
                                    )}
                                    onChange={onInputChange}
                                    disabled={getDisabledStatus}
                                  />
                                </Col>

                                <Col
                                  xs={12}
                                  md={4}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Original Basic Value *"
                                    name="originalUnitPrice"
                                    placeholder="0.00"
                                    id="originalUnitPrice"
                                    value={formatNumber(
                                      formInputs?.originalUnitPrice,
                                      "comma"
                                    )}
                                    disabled={getDisabledStatus}
                                  />
                                </Col>

                                <Col
                                  xs={12}
                                  md={4}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Basic Value *"
                                    name="vendorBasicValue"
                                    placeholder="0.00"
                                    id="vendorBasicValue"
                                    value={formatNumber(
                                      formInputs?.vendorBasicValue,
                                      "comma"
                                    )}
                                    disabled={getDisabledStatus}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Tax Amount"
                                    name="vendorTaxValue"
                                    placeholder="0.00"
                                    id="vendorTaxValue"
                                    value={formatNumber(
                                      formInputs?.vendorTaxValue,
                                      "comma"
                                    )}
                                    // onChange={onInputChange}
                                    disabled={getDisabledStatus}
                                  />
                                </Col>

                                <Col
                                  xs={12}
                                  md={4}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Other Charges"
                                    name="vendorOtherChargesValue"
                                    placeholder="0.00"
                                    id="vendorOtherChargesValue"
                                    value={formInputs?.vendorOtherChargesValue}
                                    onChange={onInputChange}
                                    disabled={getEditable}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Freight Value"
                                    name="vendorFreightValue"
                                    placeholder="0.00"
                                    id="vendorFreightValue"
                                    value={formInputs?.vendorFreightValue}
                                    onChange={onInputChange}
                                    disabled={getEditable}
                                  />
                                </Col>
                                <Col
                                  xs={12}
                                  md={4}
                                  lg={3}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  <InputField
                                    className="inputBox"
                                    label="Total Invoice Value "
                                    name="vendorTotalInvoiceValue "
                                    placeholder="0.00"
                                    id="vendorTotalInvoiceValue"
                                    value={formatNumber(
                                      Number(formInputs?.vendorBasicValue) +
                                        Number(formInputs?.vendorTaxValue) +
                                        Number(
                                          formInputs?.vendorOtherChargesValue
                                        ) +
                                        Number(formInputs?.vendorFreightValue),
                                      "comma"
                                    )}
                                    disabled={getDisabledStatus}
                                  />
                                </Col>
                              </Row>
                            </>
                            {/* )} */}
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>

              {/* Invoice Bank Details */}
            {/*   <div className="accordion mb-4" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header">
                    <Row className="accordion-button">
                      <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                        <i
                          className={`bi ${
                            isCardVisible4
                              ? "bi-chevron-right"
                              : "bi-chevron-down"
                          }`}
                          onClick={toggleCardVisibility4}
                        ></i>
                      </Col>
                      <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                        <span className="iconLogo">ID</span>
                      </Col>
                      <Col xs={12} md={9} lg={9}>
                        <span className="headerTitle">
                          Invoice Bank Details
                        </span>
                        <span className="subHeaderTitle">
                          Invoice Bank Details
                        </span>
                      </Col>

                      <Col xs={2} md={1} lg={1} className="">
                        <POCollabrationCommonFillter />
                      </Col>
                    </Row>
                  </h2>
                  <div
                    className={`accordion-collapse collapse show ${
                      isCardVisible4 ? "visible" : ""
                    }`}
                  >
                    <div className="accordion-body">
                      <Row className="pt-2 pb-4">
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Select Bank A/C Number"
                            name=""
                            placeholder=""
                            value={selectedBankDetails?.bankName}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>

                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Bank Account Holder Name"
                            name="accountHolderName"
                            placeholder=""
                            value={selectedBankDetails?.accountHolderName}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Swift Code/ IFSC Code"
                            name="ifscOrSwiftCode"
                            placeholder=""
                            value={selectedBankDetails?.ifscOrSwiftCode}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding"
                        >
                          <InputField
                            className="inputBox"
                            label="Bank Name"
                            name="bankName"
                            placeholder=""
                            value={selectedBankDetails?.bankName}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <InputField
                            className="inputBox"
                            label="Branch Address"
                            name="branchAddress"
                            placeholder=""
                            value={selectedBankDetails?.branchAddress}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <InputField
                            className="inputBox"
                            label="Bank Country"
                            name="bankCountry"
                            placeholder=""
                            value={selectedBankDetails?.bankCountry}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <InputField
                            className="inputBox"
                            label="Bank ID"
                            name="bankId"
                            placeholder=""
                            value={selectedBankDetails?.bankId}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                        <Col
                          xs={12}
                          md={4}
                          lg={4}
                          className="commTopButtonRightLeftPadding d-flex-column"
                        >
                          <InputField
                            className="inputBox"
                            label="IBAN"
                            name="iban"
                            placeholder=""
                            value={selectedBankDetails?.iban}
                            onChange={onInputChange}
                            disabled={getDisabledStatus}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div> */}
            </>
          </div>
        </Col>
      </Row>

      {/* Modal Workflow */}
      <ApproveRemarksModal
        show={modalShow}
        onHide={() => hideModal()}
        onvaluechange={handleValueChange}
      />

      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />

      {/* Success Modal Workflow */}
      <SuccessModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        successmodaldata={getsucceModalData}
        nextnavigate={getNextNavigate}
      />
    </main>
  );
};

export default InvoiceDetails;
